import log from 'salvo-lite/log'
import GoogleMapsLoader from 'google-maps'
import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'

class StoreLocator {
    constructor (theme, elem) {
        this.elem = elem
        this.mapElem = this.elem.querySelector('[data-map]')
        this.storeElems = this.elem.querySelectorAll('[data-store]')
        this.mapSearchElem = this.elem.querySelector('[data-map-search]')
        this.mapSearchInput = this.mapSearchElem ? this.mapSearchElem.querySelector('[data-search-field]') : null
        this.clearSearchButton = this.mapSearchElem ? this.mapSearchElem.querySelector('[data-clear]') : null
        this._defaultLat = this.elem.querySelector('[data-default-lat]').value
        this._defaultLong = this.elem.querySelector('[data-default-long]').value
        this._zoom = this.elem.querySelector('[data-zoom]').value
        this.map = L.map(this.mapElem).setView([this._defaultLat, this._defaultLong], this._zoom)
        this.standardIcon = L.divIcon({ className: 'cicon' })
        this.userMarker = false
        this.geocoder = false
        this.markers = []
        this.googleLayer = false
        this.stores = this.elem.querySelector('[data-stores-json]') ? JSON.parse(this.elem.querySelector('[data-stores-json]').innerHTML).stores : []
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)

        GoogleMapsLoader.KEY = 'AIzaSyBri-9rLBk9bM9hRvo4ey3duiGhtaFLIgM'
        GoogleMapsLoader.load((google) => {
            this.google = google
            this.googleLayer = new L.GridLayer.GoogleMutant({
                type: 'roadmap',
                styles: [{ 'featureType': 'water', 'elementType': 'geometry', 'stylers': [{ 'color': '#e9e9e9' }, { 'lightness': 17 }] }, { 'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 20 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 17 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 29 }, { 'weight': 0.2 }] }, { 'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 18 }] }, { 'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'poi', 'elementType': 'geometry', 'stylers': [{ 'color': '#f5f5f5' }, { 'lightness': 21 }] }, { 'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [{ 'color': '#dedede' }, { 'lightness': 21 }] }, { 'elementType': 'labels.text.stroke', 'stylers': [{ 'visibility': 'on' }, { 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'elementType': 'labels.text.fill', 'stylers': [{ 'saturation': 36 }, { 'color': '#333333' }, { 'lightness': 40 }] }, { 'elementType': 'labels.icon', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'transit', 'elementType': 'geometry', 'stylers': [{ 'color': '#f2f2f2' }, { 'lightness': 19 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 20 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 17 }, { 'weight': 1.2 }] }]
            })
            this.geocoder = new this.google.maps.Geocoder()
            this.googleLayer.addTo(this.map)
            this.mapReady()
        })

        log.debug(this.constructor.name, 'Initialized', this)
    }

    mapReady () {
        for (let [index, store] of this.stores.entries()) {
            let marker = L.marker([store.lat, store.lon], { icon: this.standardIcon })
            marker.bindPopup(`<b>${store.title}</b><br>${store.address}`)
            marker.addTo(this.map)
            this.markers.push({ lat: store.lat, lon: store.lon, marker: marker })
            console.log(index)
        }

        for (let storeElem of this.storeElems) {
            storeElem.addEventListener('click', (e) => {
                if (storeElem.dataset.lat && storeElem.dataset.lon) {
                    e.preventDefault()
                    let lat = parseFloat(storeElem.dataset.lat)
                    let lon = parseFloat(storeElem.dataset.lon)
                    this.map.setView([lat, lon], this._zoom)
                }
            })
        }

        if (this.mapSearchInput) {
            this.mapSearchInput.addEventListener('input', (e) => {
                if (this.mapSearchInput.value.length > 0) {
                    this.clearSearchButton.classList.add('shown')
                } else {
                    this.clearSearchButton.classList.remove('shown')
                }
            })
        }

        if (this.clearSearchButton) {
            this.clearSearchButton.addEventListener('click', (e) => {
                e.preventDefault()
                this.mapSearchInput.value = ''
                this.clearSearchButton.classList.remove('shown')
                this.map.setView([this._defaultLat, this._defaultLong], this._zoom)
            })
        }

        if (this.mapSearchElem) {
            this.mapSearchElem.addEventListener('submit', (e) => {
                e.preventDefault()
                let postcode = this.mapSearchInput.value.trim()
                if (postcode === '') {
                    let firstMarker = this.markers[0]
                    this.map.setView([firstMarker.lat, firstMarker.lon], this._zoom)
                    return
                }
                this.geocoder.geocode({
                    address: postcode
                }, (data) => {
                    let lat = data[0].geometry.location.lat()
                    let lon = data[0].geometry.location.lng()
                    if (this.userMarker) {
                        this.map.removeLayer(this.userMarker)
                    }
                    this.userMarker = L.marker([lat, lon], { icon: this.standardIcon }).addTo(this.map)
                    this.map.setView([lat, lon], this._zoom)
                })
            })
        }
    }
}

export default StoreLocator



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StoreLocator.js